import React, { useState } from 'react';
import axios from 'axios';

import CustomModal from '../Elements/CustomModal';

/**
 * Alta de canal — solo superadmin (el API lo exige también). Sin tienda
 * seleccionada el canal es interno del equipo (venue_id null).
 */
export default function CreateChannelModal({ active, token, venues = [], onCerrar, onCreado }) {
  const [nombre, setNombre] = useState('');
  const [tema, setTema] = useState('');
  const [venueId, setVenueId] = useState('');
  const [error, setError] = useState('');
  const [enviando, setEnviando] = useState(false);

  const cerrar = () => {
    if (enviando) return;
    setNombre('');
    setTema('');
    setVenueId('');
    setError('');
    onCerrar();
  };

  const crear = async () => {
    const limpio = nombre.trim();
    if (!limpio) {
      setError('El canal necesita un nombre.');
      return;
    }
    setEnviando(true);
    setError('');
    try {
      const r = await axios.post(
        '/v1/smack/channels',
        { venue_id: venueId || null, name: limpio, topic: tema.trim() || null },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      onCreado(r.data);
      cerrar();
    } catch (err) {
      setError(err?.response?.data?.detail || 'No se pudo crear el canal.');
    } finally {
      setEnviando(false);
    }
  };

  const footer = (
    <>
      <button type="button" className="wa-btn-secondary" onClick={cerrar} disabled={enviando}>
        Cancelar
      </button>
      {/* #FF5400: acento de marca de Smack (decisión 22-ago: se queda) — fuera de tokens.css a propósito: el design system es slate y este naranja es exclusivo del módulo. */}
      <button
        type="button"
        onClick={crear}
        disabled={enviando}
        className="rounded-lg bg-[#FF5400] px-3 py-2 text-sm font-medium text-white disabled:bg-gray-300"
      >
        {enviando ? 'Creando…' : 'Crear canal'}
      </button>
    </>
  );

  return (
    <CustomModal
      active={active}
      handleModal={cerrar}
      title="Nuevo canal"
      size="sm"
      titleId="smack-nuevo-canal"
      footer={footer}
    >
      <div className="space-y-3">
        <label className="block">
          <span className="mb-1 block text-xs font-medium text-gray-700">Tienda</span>
          <select
            value={venueId}
            onChange={(e) => setVenueId(e.target.value)}
            className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:border-[#FF5400] focus:outline-none"
          >
            <option value="">Canal interno del equipo</option>
            {venues.map((venue) => (
              <option key={venue.id} value={venue.id}>
                {venue.name}
              </option>
            ))}
          </select>
        </label>

        <label className="block">
          <span className="mb-1 block text-xs font-medium text-gray-700">Nombre</span>
          <input
            type="text"
            value={nombre}
            onChange={(e) => setNombre(e.target.value)}
            maxLength={80}
            placeholder="incidencias"
            className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:border-[#FF5400] focus:outline-none"
          />
        </label>

        <label className="block">
          <span className="mb-1 block text-xs font-medium text-gray-700">Tema (opcional)</span>
          <input
            type="text"
            value={tema}
            onChange={(e) => setTema(e.target.value)}
            maxLength={255}
            className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:border-[#FF5400] focus:outline-none"
          />
        </label>

        {error ? <p className="text-xs text-red-600">{error}</p> : null}
      </div>
    </CustomModal>
  );
}
